<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "components.selected-leads-routing.panel-title" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
        max-width: 400px;
      "
    >
      <mat-card appearance="outlined">
        <mat-card-content>
          <p>
            {{
              "components.selected-leads-routing.mode-of-transport-description"
                | translate
            }}
          </p>
          <mat-form-field>
            <mat-label>{{
              "components.selected-leads-routing.mode-of-transport" | translate
            }}</mat-label>
            <mat-select [(ngModel)]="modeOfTransport">
              @for (modeOfTransport of modesOfTransport; track $index) {
                <mat-option [value]="modeOfTransport">{{
                  "enums.modeOfTransport." + modeOfTransport | translate
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-content>
          <p>
            {{
              "components.selected-leads-routing.opening-times-description"
                | translate
            }}
          </p>
          <mat-checkbox #withOpeningTimesCheckbox>{{
            "components.selected-leads-routing.with-openingTimes-checkbox"
              | translate
          }}</mat-checkbox>
        </mat-card-content>
      </mat-card>
    </div>

    <button
      mat-button
      (click)="calculateRoute(withOpeningTimesCheckbox.checked)"
    >
      {{
        "components.selected-leads-routing.calculate-route-button" | translate
      }}
    </button>

    @if (routeCalculationInProgress) {
      <div class="route-calculation-progress">
        <mat-progress-spinner mode="indeterminate" />
      </div>
    }

    @if (rout) {
      <mat-divider class="content-divider" />
      <div>
        <div class="stop-item-column">
          <button mat-icon-button (click)="rout.expanded = !rout.expanded">
            <mat-icon>
              {{ rout.expanded ? "expand_more" : "chevron_right" }}
            </mat-icon>
          </button>
          <div
            class="stop-item-text"
            (click)="rout.expanded = !rout.expanded"
            (keydown.enter)="
              $event.preventDefault(); rout.expanded = !rout.expanded
            "
            (keydown.space)="
              $event.preventDefault(); rout.expanded = !rout.expanded
            "
            tabindex="0"
            role="button"
            [attr.aria-expanded]="rout.expanded"
          >
            {{ timeToString(rout.start) }}
            <span>
              {{
                "components.selected-leads-routing.route-summary.start"
                  | translate
              }}
            </span>
          </div>
        </div>
        @if (rout.expanded) {
          <div class="content">
            <app-key-value-table
              [keyValues]="rout.keyValues"
            ></app-key-value-table>
          </div>
        }
        @for (r of rout.routeElements; track r) {
          <div>
            <div class="stop-item-column">
              <button mat-icon-button (click)="r.expanded = !r.expanded">
                <mat-icon>
                  {{ r.expanded ? "expand_more" : "chevron_right" }}
                </mat-icon>
              </button>
              <div
                class="stop-item-text"
                (click)="r.expanded = !r.expanded"
                (keydown.enter)="
                  $event.preventDefault(); r.expanded = !r.expanded
                "
                (keydown.space)="
                  $event.preventDefault(); r.expanded = !r.expanded
                "
                tabindex="0"
                role="button"
                [attr.aria-expanded]="r.expanded"
              >
                {{ timeToString(r.arrival) }}
                <span>{{ r.name }}</span>
              </div>
            </div>
            @if (r.expanded) {
              <div class="content">
                <app-key-value-table
                  [keyValues]="r.keyValues"
                ></app-key-value-table>
              </div>
            }
          </div>
        }
      </div>
    }
  </mat-expansion-panel>
</mat-accordion>
